<template>
  <div
    :class="[
      'group relative z-20 shrink-0 select-none touch-none',
      direction === 'horizontal'
        ? 'w-1.5 cursor-col-resize hover:bg-unibo-red/40 active:bg-unibo-red/60'
        : 'h-1.5 cursor-row-resize hover:bg-unibo-red/40 active:bg-unibo-red/60',
      active ? 'bg-unibo-red/50' : 'bg-slate-800/80',
    ]"
    :title="direction === 'horizontal' ? 'Drag to resize panels' : 'Drag to resize console'"
    @pointerdown="onPointerDown"
  >
    <div
      :class="[
        'absolute bg-slate-500/50 rounded-full opacity-0 group-hover:opacity-100 transition-opacity',
        direction === 'horizontal'
          ? 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1 h-8'
          : 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-1 w-8',
      ]"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeUnmount } from 'vue';

const props = defineProps<{
  direction: 'horizontal' | 'vertical';
}>();

const emit = defineEmits<{
  (e: 'resize', delta: number): void;
  (e: 'resize-end'): void;
}>();

const active = ref(false);
let startPos = 0;
let pointerId: number | null = null;

function onPointerDown(ev: PointerEvent) {
  ev.preventDefault();
  active.value = true;
  pointerId = ev.pointerId;
  startPos = props.direction === 'horizontal' ? ev.clientX : ev.clientY;
  (ev.currentTarget as HTMLElement).setPointerCapture(ev.pointerId);
  window.addEventListener('pointermove', onPointerMove);
  window.addEventListener('pointerup', onPointerUp);
  window.addEventListener('pointercancel', onPointerUp);
  document.body.style.cursor = props.direction === 'horizontal' ? 'col-resize' : 'row-resize';
  document.body.style.userSelect = 'none';
}

function onPointerMove(ev: PointerEvent) {
  if (!active.value) return;
  const pos = props.direction === 'horizontal' ? ev.clientX : ev.clientY;
  const delta = pos - startPos;
  startPos = pos;
  if (delta !== 0) emit('resize', delta);
}

function onPointerUp() {
  if (!active.value) return;
  active.value = false;
  pointerId = null;
  window.removeEventListener('pointermove', onPointerMove);
  window.removeEventListener('pointerup', onPointerUp);
  window.removeEventListener('pointercancel', onPointerUp);
  document.body.style.cursor = '';
  document.body.style.userSelect = '';
  emit('resize-end');
}

onBeforeUnmount(() => {
  onPointerUp();
});
</script>
